import React, { useState } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

interface PasswordFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
  helperText?: string;
  autoComplete?: 'current-password' | 'new-password';
}

/** Visibility is local to each field; toggling it never submits the enclosing form. */
export const PasswordField = ({
  id,
  label,
  value,
  onChange,
  disabled,
  error,
  helperText,
  autoComplete = 'new-password',
}: PasswordFieldProps) => {
  const [visible, setVisible] = useState(false);
  return (
    <FormControl isRequired isDisabled={disabled} isInvalid={!!error}>
      <FormLabel htmlFor={id} fontSize="sm">
        {label}
      </FormLabel>
      <InputGroup>
        <Input
          id={id}
          name={id}
          type={visible ? 'text' : 'password'}
          autoComplete={autoComplete}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          pr={12}
        />
        <InputRightElement>
          <IconButton
            type="button"
            aria-label={`${visible ? 'Hide' : 'Show'} ${label.toLowerCase()}`}
            aria-pressed={visible}
            icon={visible ? <FiEyeOff /> : <FiEye />}
            onClick={() => setVisible((current) => !current)}
            isDisabled={disabled}
            variant="ghost"
            size="sm"
          />
        </InputRightElement>
      </InputGroup>
      {error ? (
        <FormErrorMessage>{error}</FormErrorMessage>
      ) : helperText ? (
        <FormHelperText fontSize="xs">{helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
};
